import React, {
  PropsWithChildren,
} from 'react';
import MediaProvider from 'core/context/media';
import SignalRHubProvider from 'core/context/signalRHub';
import ConfirmationDialogProvider from 'pages/Dashboard/contexts/confirmationDialog';
import FileViewerProvider from 'pages/Dashboard/contexts/fileViewer';
import UserSettingsProvider from 'pages/Dashboard/contexts/userSettings';
import SidePanelProvider from 'pages/Dashboard/contexts/sidePanel/SidePanelProvider';
import panelRegistry from 'pages/Dashboard/contexts/sidePanel/panelCatalog';
import StoreProvider from 'views/EMR/stores/StoreProvider';

type ProvidersProps = PropsWithChildren<{
  canUseMedia?: boolean;
  canUseRealTime?: boolean;
}>;

export default function Providers({
  children,
  canUseMedia = true,
  canUseRealTime = true,
}: ProvidersProps) {
  return (
    <SignalRHubProvider canUseRealTime={canUseRealTime}>
      <StoreProvider>
        <UserSettingsProvider>
          <ConfirmationDialogProvider>
            <FileViewerProvider>
              <MediaProvider canUseMedia={canUseMedia}>
                <SidePanelProvider registry={panelRegistry}>
                  {children}
                </SidePanelProvider>
              </MediaProvider>
            </FileViewerProvider>
          </ConfirmationDialogProvider>
        </UserSettingsProvider>
      </StoreProvider>
    </SignalRHubProvider>
  );
}
